import { useDispatch } from 'react-redux';
import { ProgressProps, uploadsActions } from '..';

const useProgressListener = () => {
  const dispatch = useDispatch();

  const listener = (props: ProgressProps) => {
    dispatch(uploadsActions.updateProgress(props));
  };

  return listener;
};

export default useProgressListener;
